import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const counterpartyGroupMembersQueryAtom = createQueryAtomFactory(
  'brokerage.counterpartyGroupMembers',
  (params: { groupId: string }) => ({
    counterpartyGroupMembers: {
      __args: {
        groupId: params.groupId,
      },
    },
  }),
  {
    select: (data): string[] =>
      (data?.counterpartyGroupMembers as string[]) ?? [],
  },
);
